import React from 'react';
import styled from 'styled-components';

const Container  = styled.div`
    padding: 5rem;
`;

const FE = props => {

  return (
    <Container>
      <h3>Dev - Fe channel</h3>
    </Container>
  );
};

FE.propTypes = {};

export default FE;
